// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-img img {
  filter: invert(1);
  position: absolute;
  left: 15px;
  top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AACF","sourcesContent":[".logo-img  img{  \n  filter: invert(1);\n  position:absolute;\n  left:15px;\n  top: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
